module.exports = __webpack_public_path__ + "img/compensave.f7fb76ae.svg";